import React from 'react';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core';

import { CloseIcon } from 'ha/ui/next/Icons';
import { withIntl, IntlProps } from 'ha/i18n';
import AppBar from 'ha/ui/next/AppBar';
import IconButton from 'ha/ui/next/IconButton';
import { Typography } from 'ha/ui/next/Typography';
import Grid from 'ha/ui/next/Grid';
import units from 'ha/theme/units';
import Button from 'ha/ui/next/Button';

import AuthModalActions from 'ha/modules/NavBar/containers/AuthModalActions';

export const styles = (theme: Theme) =>
  createStyles({
    content: {
      margin: units.rem(1),
      [theme.breakpoints.up('md')]: {
        alignItems: 'center',
        justifyContent: 'center',
      },
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    text: {
      [theme.breakpoints.up('md')]: {
        marginRight: units.rem(1),
      },
      [theme.breakpoints.down('sm')]: {
        marginBottom: units.rem(1),
      },
    },
    bar: {
      position: 'relative',
      boxShadow: '0 3px 9px rgba(0, 0, 0, 0.5)',
      backgroundColor: theme.palette.white.main,
    },
    closeButton: {
      position: 'absolute',
      right: 0,
    },
  });

interface Props {
  onClose: React.MouseEventHandler<HTMLElement>;
}

export const SuggestionBar: React.FC<
  Props & IntlProps & WithStyles<typeof styles>
> = ({ intl: { T }, classes, onClose }) => (
  <AppBar position="static" color="default" className={classes.bar}>
    <Grid container>
      <Grid container item xs className={classes.content}>
        <div className={classes.text}>
          <Typography.ParagraphTitle data-test-locator="Suggestion Bar Title">
            {T('Reach out to advertisers directly')}
          </Typography.ParagraphTitle>
        </div>

        <AuthModalActions>
          {({ onRegisterClick }) => (
            <Button
              variant="contained"
              color="primary"
              onClick={onRegisterClick}
              data-test-locator="Suggestion Bar CTA"
            >
              {T('Sign up')}
            </Button>
          )}
        </AuthModalActions>
      </Grid>
      <Grid item className={classes.closeButton}>
        <IconButton
          onClick={onClose}
          data-test-locator="Suggestion Bar Close icon"
        >
          <CloseIcon />
        </IconButton>
      </Grid>
    </Grid>
  </AppBar>
);

export default withStyles(styles)(withIntl(SuggestionBar));
